import React, { Component } from 'react';
import styled from 'styled-components/macro';
import scaleSize from '../utils/scale-size';
import moment from 'moment';
import 'moment/locale/uk';
import 'moment/locale/en-gb';
import 'moment/locale/ru';
import PropTypes from 'prop-types';
import { INIT_UI_LANGUAGE } from 'constants/languages';

const ClockWrapper = styled.div`
  width: ${scaleSize(264)}px;
  height: ${scaleSize(80)}px;
  border-radius: ${scaleSize(40)}px;
  background-color: ${({ theme }) => theme.imagePlaceholder};
  font-family: 'RobotoRegular', sans-serif;
  font-size: ${scaleSize(34)}px;
  font-weight: bold;
  font-stretch: condensed;
  font-style: normal;
  line-height: ${scaleSize(80)}px;
  letter-spacing: normal;
  text-align: center;
  position: absolute;
  z-index: 10;
  top: ${({ type }) => (type === 'EPG' ? 0 : scaleSize(30))}px;
  right: ${({ type }) => (type === 'EPG' ? 'auto' : `${scaleSize(80)}px`)};
  color: ${({ theme }) => theme.mainTextColor};
  margin-top: ${(props) => scaleSize(props.hide ? -300 : 0)}px;
  transition: ${({ noAnimation }) => (!noAnimation ? `margin-top ease-out 0.3s` : 'none')};
`;

const ONE_MINUTE = 1000 * 60;

class Clock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      time: new Date(),
    };
  }
  componentDidMount() {
    this.intervalID = setInterval(() => this.tick(), ONE_MINUTE);
  }
  componentWillUnmount() {
    clearInterval(this.intervalID);
  }
  tick() {
    this.setState({
      time: new Date(),
    });
  }
  render() {
    return (
      <ClockWrapper {...this.props}>
        {moment(this.state.time).locale(INIT_UI_LANGUAGE).format('D MMM, HH:mm')}
      </ClockWrapper>
    );
  }
}

Clock.propTypes = {
  hide: PropTypes.bool,
};

export default Clock;
